import {observable, action, runInAction, computed} from 'mobx';
import {DeviceInfo} from "qunar-react-native";

import {getLocationCity} from '../../common/hysdkUtils/location';
import qhotdog from '../../common/hysdkUtils/request';
import {handleLowPriceData, canJumpToGlobalPrice, addGoDate, diff, paramUrl, getQueryParam} from './util';
import {getScreenSize} from '../../common/utils';

import UserSelectLogic from './userSelectLogic';
import FilterConfigLogic from './filterConfigLogic';
import DateUtils from '../../common/DateUtils';
import defaultFilterUtils from '../../common/defaultFilterUtils';

import constants  from './constraints';
import {getItem, setItem} from '../../common/StorageUtils';

export default class SearchModels{
    @observable.ref filterVisible = false;
    @observable.ref filterData = {}; // 请求到的处理后的数据

    @observable.ref selectedMonths = [];
    @observable.ref selectedWeeks = [];
    @observable.ref selectedDays = constants.DEFAULT_DAY_OBJ;
    @observable.ref customDays = {};

    @observable.ref customize = false;

    @observable.ref windowWidth = getScreenSize().width;

    @observable.ref depCityList = constants.DEFAULT_DEP_CITY_LIST;
    @observable.ref arrCityList = constants.EMPTY_CITY_LIST;

    @observable.ref flightType = ''; // 单程
    @observable.ref canExchangePlace = true;
    @observable.ref curCityList = '';
    @observable.ref locationHandler = getLocationCity();
    @observable.ref calendarInfo = '';

    @observable.ref calendarVisible = false;

    constructor(rootStore) {
        this.rootStore = rootStore;
        window.onresize = () => {
            this.windowWidth = getScreenSize().width
        }
        this.initCityList();
        this.initFlightType();
    }

    @action.bound
    async initFlightType() {
        let flightType = await getItem("flightType");
        this.flightType = flightType || constants.FLIGHT_TYPE.ONE_WAY;
    }


    @action.bound
    async initCityList(locationCity) {

        let depCityData = await getItem("depCityList");
        let arrCityList = await getItem("arrCityList");
        let paramDepCity = getQueryParam('depCity');
        let paramArrCity = getQueryParam('arrCity');

        if (paramDepCity) {
            this.depCityList = [{name: paramDepCity}]
        } else if (depCityData) {
            this.depCityList = depCityData && JSON.parse(depCityData) || constants.DEFAULT_DEP_CITY_LIST;
        } else {
            if (locationCity) {
                this.depCityList = [{name: locationCity}];
            }
        }

        if (paramArrCity) {
            this.arrCityList = [{name: paramArrCity}];
        } else {
            this.arrCityList = arrCityList && JSON.parse(arrCityList) || constants.EMPTY_CITY_LIST;
        }

        this.canExchangePlace = !canJumpToGlobalPrice(this.arrCityList);
    }

    @computed
    get logData(){
        return {
            dep: this.depCity,
            arr: this.arrCity,
            is_round: this.flightType === 2,
            flight_type: this.flightType
        }
    }
    @computed
    get userSelect () {
        if(!this.customize) {
            return {
                tag: this.selectedMonths.map((month) => {return month.value}).join('、'),
                tagNames: this.selectedMonths.map((month) => {return month.text}).join('、'),
                days: this.selectedDays.start ? this.selectedDays.start + '-' + this.selectedDays.end : constants.DEFAULT_DAY,
                weeks: this.selectedWeeks.join('、'),
                startDate: '',
                endDate: ''
            }
        } else {
            return {
                tag: -1,
                tagNames: '',
                days: constants.DEFAULT_DAY,
                weeks: '',
                startDate: this.customDays.startDate,
                endDate: this.customDays.endDate
            }
        }
    }

    @computed
    get depCity () {
        let curCity = (this.depCityList && this.depCityList[0]) || {};
        return curCity.search || curCity.name || '';
    }

    @computed
    get arrCity () {
        return this.arrCityList.map((item, i) => {
            return item.search || item.name || '';
        }).join('、')
    }

    @computed
    get userSelectStr () {
        const {tagNames, weeks, days, startDate, endDate, tag} = this.userSelect;
        const week_str = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];

        let userSelectStr;

        let showDays = (days && days !== constants.DEFAULT_DAY) ? days : '';

        let dayArr = showDays.split('-') || [];
        if (dayArr[0] === dayArr[1]) {
            showDays = dayArr[0].toString();
        }

        if (parseInt(tag) === -1) {
            if(startDate === endDate || !endDate) {
                userSelectStr =  DateUtils.dateFormat(startDate, 'MM月dd日');
            } else {
                userSelectStr = DateUtils.dateFormat(startDate, 'MM月dd日') + '~' + DateUtils.dateFormat(endDate, 'MM月dd日');
            }

        } else {
            let weeksStr = weeks ? weeks.split('、').map((i) => {
                return i ? week_str[i - 1] : '';
            }).join('、') : '';

            if (this.flightType === 2) {
                userSelectStr = tagNames + (weeksStr ? ' | ' + weeksStr : '') + (showDays ? ' | ' + showDays + '天' : '');
            } else {
                userSelectStr = tagNames + (weeksStr ? ' | ' + weeksStr : '');
            }
        }

        return userSelectStr;
    }


    @computed
    get selectedMonthsMap(){
        let selectMap = {};
        this.selectedMonths.forEach((item) => {
            selectMap[item.text] = {
                filterType: item.filterType
            };
        });

        return selectMap;
    }

    @computed
    get usableWeeksMap () {
        if(this.customize) {
            weeksMap = constants.DEFAULT_WEEKS_MAP;
            return weeksMap
        }
        let weeksMap = {};
        // 取并集
        let months = this.filterData.months;

        months && months.map((item) => {
            if (this.selectedMonthsMap[item.text]) {
                let curWeeks = item.weeks || [];
                curWeeks.map((week) => {
                    weeksMap[week] = true;
                });
            }
        });

        return weeksMap
    }

    @computed
    get usableWeeks () {
        return Object.keys(this.usableWeeksMap)
    }


    @computed
    get selectedUsableWeeks() {
        return this.selectedWeeks.map((item) => { return !this.usableWeeksMap[item]})
    }

    @computed
    get goToGlobalPrice() {
        return canJumpToGlobalPrice(this.arrCityList)
    }

    @computed
    get jumpUrl () {
        const appId = getQueryParam('appId');
        if (canJumpToGlobalPrice(this.arrCityList)) {
            let baseUrl = 'https://m.flight.qunar.com/hy/globalPrice#/home?param=';
            const {tag, days, startDate, endDate} = this.userSelect || {};
            let {uid, gid} = DeviceInfo || {};

            let options = {
                uid: uid,
                sortType: 0,
                cat: this.handleCurrentCat(),
                gid: gid,
                conditions: {value: this.arrCityList},
                tripType: this.flightType - 1,
                depTime: this.getGlobalPriceTime(tag, startDate, endDate),
                depCity: this.depCity,
                selectPriceCeiling: 1,
                selectPriceFloor: 0,
                travelDays: this.flightType - 1 && days && days.split('-').map((item) => {
                    return parseInt(item);
                })
            };

            let url = baseUrl + encodeURIComponent(JSON.stringify(options));
            return url
        } else {
            const {startDate, endDate, tag, tagNames, weeks, days} = this.userSelect;

            let accurateDateNames;
            if(!endDate || startDate === endDate) {
                accurateDateNames = DateUtils.dateFormat(startDate, 'MM月dd日')
            } else {
                accurateDateNames = DateUtils.dateFormat(startDate, 'MM月dd日') + '~' + DateUtils.dateFormat(endDate, 'MM月dd日')
            }

            let cat = getQueryParam('cat');
            let data = {
                env: 0,
                dep: this.depCity,
                arr: this.arrCity,
                flightType: this.flightType,
                catCopy: cat,
                cat: this.handleCurrentCat(),
                tag: tag,
                weeks: weeks,
                days: this.flightType === 2 && tag !== -1 ? days : '',
                tagNames: tagNames,
                accurateDateNames: accurateDateNames,
                startDate: startDate,
                endDate: endDate,
                monitorTime: 0,
                monitorLowestPrice: 0,
                hywebkit: 1,
                appId
            };


            let ONEWAY_BASE_URL = 'https://touch.qunar.com/lowFlight/flightList?';
            let ROUNDWAY_BASE_URL = 'https://touch.qunar.com/lowFlight/roundTrip?';

            let baseUrl = this.flightType === 1 ? ONEWAY_BASE_URL : ROUNDWAY_BASE_URL
            let jumpUrl = baseUrl + paramUrl(data);
            return jumpUrl;

        }
    }

    handleCurrentCat() {
        let cat = getQueryParam('cat') || '';
        let flightType = this.flightType === 1 ? 'OneWay' : 'Round';

        if(canJumpToGlobalPrice(this.arrCityList)) {
            return cat + '_multi' + flightType
        } else {
            return cat + `_${flightType}` + '-search-box'
        }
    }

    getGlobalPriceTime (tag, originStartDate, originEndDate) {
        if (!tag) {
            return {};
        }

        let startDate;
        let endDate;
        if (tag === -1) {
            // 自定义
            startDate = originStartDate;
            endDate = originEndDate || addGoDate(originStartDate, 1);
        } else {
            // 其他
            let rangeArr = tag.split('、') || [];
            let rangeArrLength = rangeArr.length;
            startDate = rangeArr[0].split(':')[0].split('|')[0];
            endDate = rangeArr[rangeArrLength - 1].split(':')[0].split('|')[1];
            rangeArr.map((range) => {
                let curRange = range.split(':')[0];
                let start = curRange.split('|')[0];
                let end = curRange.split('|')[1];

                if (diff(start, startDate) < 0) {
                    startDate = start;
                }

                if (diff(endDate, end) < 0) {
                    endDate = end;
                }
            });
        }

        return {
            startTime: startDate,
            endTime: endDate
        };
    }

    // calendar
    @action.bound
    handleCalendarStatus(visible){
        this.calendarVisible = visible
    }

    @action.bound
    initCalendar(calendarInfo) {
        this.calendarInfo = calendarInfo
    }

    // flightType
    @action.bound
    handleSelectFlightType = async (item) => {
        this.flightType = item.flightType;
        setItem('flightType', item.flightType);
        await this.fetchData();
    };

    //city相关
    @action.bound
    exchangeCity = () => {
        let temp = [].concat(this.arrCityList);
        let tempDep = [].concat(this.depCityList);
        this.getDepCity(temp);
        this.getArrCity(tempDep);
    };

    @action.bound
    getDepCity = (cityList) => {
        this.depCityList = cityList;
        setItem('depCityList', JSON.stringify(this.depCityList));
    };

    @action.bound
    getArrCity = (cityList) => {
        this.arrCityList = cityList;
        this.canExchangePlace = !canJumpToGlobalPrice(this.arrCityList);
        setItem('arrCityList', JSON.stringify(this.arrCityList));
    };

    // searchFilter
    @action.bound
    handleSearchFilter = (type) => {
        this.filterVisible = type === 'show';
        if(!type){
            this.initUserSelect();
        }

    };

    @action.bound
    async fetchData() {
        try {
            let filterStorage = await FilterConfigLogic.getFilterConfigStorage();
            let defaultRes;
            if(filterStorage){
                filterStorage = JSON.parse(filterStorage);
                defaultRes = FilterConfigLogic.getUsableFilterConfig(filterStorage);
            } else {
                defaultRes = defaultFilterUtils.getFilterDataSet(false, false, false);
            }
            this.filterData = handleLowPriceData(defaultRes);
            this.initUserSelect();

            GodEye.log({
                r: 'req_filter_total'
            });
            let response = await qhotdog({
                url: '/lowFlightInterface/api/getFilterConfig',
                method: 'POST',
                requestType: 'json',
                body: {
                    flightType: this.flightType,
                    areSupportCalendar: true,
                    arrCity: this.arrCity || '上海',
                    depCity: this.depCity || '北京',
                    t: 'f_urInfo_lowPriceFlight_filter',
                    simpleData: 'yes'
                }
            });
            let result;
            if(response && response.data) {
                result = response.data;
                GodEye.log({
                    r: 'req_filter_success'
                });
            } else {
                result = defaultFilterUtils.getFilterDataSet(false, false, false);
                GodEye.log({
                    r: 'req_filter_fail'
                });
            }

            runInAction(async () => {
                FilterConfigLogic.setFilterConfigStorage(result);
                this.filterData = handleLowPriceData(result);
                await this.initUserSelect();
                UserSelectLogic.setSelectedDataStorage(this.userSelect)
            });

        } catch (e) {
            GodEye.log({
                r: 'req_filter_error'
            });
        }
    }

    @action.bound
    async initUserSelect(userSelect) {
        userSelect = userSelect || await UserSelectLogic.calcUserSelect(this.filterData);
        this.customize = userSelect.tag == -1;
        this.selectedMonths = this.customize ? [] : UserSelectLogic.getSelectedMonths(this.filterData, userSelect);
        this.selectedWeeks = this.customize  ? [] : UserSelectLogic.getSelectedWeeks(this.usableWeeks, userSelect);
        this.selectedDays =  UserSelectLogic.getSelectDays(userSelect);
        this.customDays = this.customize ? {
            startDate: userSelect.startDate,
            endDate: userSelect.endDate
        } : {}
    }

    @action.bound
    handleSelectMonth = (item) => {
        if(this.customize) {
            let defaultSelect = UserSelectLogic.getDefaultUserSelect(this.filterData);
            this.initUserSelect(defaultSelect);
        }

        this.customize = false;
        let activeStatus = this.selectedMonthsMap[item.text];

        if(activeStatus) {
            // 取消选中
            if(this.selectedMonths.length === 1) {
                return;
            }
            this.selectedMonths = this.selectedMonths.filter((month) => {
                return month.text !== item.text
            })
        } else {
            // 选中
            let filterMapHasSelected = this.selectedMonthsMap[item.text];
            this.selectedMonths.push(item);

            if(!filterMapHasSelected){
                this.selectedMonths = this.selectedMonths.filter((months) => {
                    return months.filterType === item.filterType
                })
            }
        }
    };

    @action.bound
    handleSelectWeeks = (week) => {
        if(this.customize) {
            let defaultSelect = UserSelectLogic.getDefaultUserSelect(this.filterData);
            this.initUserSelect(defaultSelect);
        }

        this.customize = false;
        let weeks = [].concat(this.selectedWeeks);
        let activeStatus = weeks.indexOf(week) > -1;
        if(activeStatus){
            // 取消选中
            weeks = weeks.filter((item) => {return item !== week});
        } else {
            // 选中
            if(this.usableWeeksMap[week]){
                weeks.push(week);
            }
        }
        this.selectedWeeks = weeks;
    };

    @action.bound
    handleSelectDays = (days) => {
        if(this.customize) {
            let defaultSelect = UserSelectLogic.getDefaultUserSelect(this.filterData);
            this.initUserSelect(defaultSelect);
        }

        this.customize = false;
        this.selectedDays = days;
    };


    @action.bound
    handleSubmit = () => {
        UserSelectLogic.setSelectedDataStorage(this.userSelect);
        this.handleSearchFilter();
    };

    @action.bound
    selectCustomDate = (dateArr) => {
        this.customDays = {
            startDate: dateArr[0],
            endDate: dateArr[1]
        };
        this.customize = true;
        this.handleSubmit();
    }

    @action.bound
    setCityComp = (type, comp) => {
        this[type] = comp;
    }
}
